import React, { useState, useEffect } from "react";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import axiosInstance from "../../../../../http.common";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import { format } from "date-fns";


const AddNewUser = () => {

  const businessPartnerId = localStorage.getItem("business_partner_id")
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem("UserType")
  const [Required,setRequired] = useState(false)

    const [formData, setFormData] = useState({});
  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [designationInputs, setDesignationInputs] = useState([]);
  const [ roleOptions, setRoleOptions ] = useState([])
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [ businessPartnerOptions, setBusinessPartnerOptions ] = useState([])

  const DesignationInputsTemplate = [
    ...(userType === "superadmin" || userType === "businesspartner"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: businessPartnerOptions,
            gridClass: "col-lg-4",
            validation: { required: true,
            
           },
           
          },
        ]
      : []),
      {
        name: "firstname",
        label: "First Name",
        placeholder:"Enter First Name",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
         validation: { required: true,
          pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
       },
      },
      {
        name: "lastname",
        label: "Last Name",
        placeholder:"Enter Last Name",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
         validation: { required: true,
          pattern: /^[A-Za-z0-9-\s]*$/,
          message: "Special symbols are not allowed",
        maxLength:15
       },
      },
      {
        name: "email",
        label: "Email ID",
        placeholder:"Enter Email Address",
        type: "email",
        required: true,
        gridClass: "col-lg-4",  
        validation: { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ , message: "Please enter a valid Email ID"},
      },
      {
        name: "dob",
        label: "DOB",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, message: "DOB is required", },
      },
      {
        name: "jddob",
        label: "Joining Date",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, message: "Joining Date is required" },
      },
      {
        name: "contactno",
        label: "Contact No.",
        placeholder:"Enter Contact No.",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { 
          required: true, pattern: /^[6-9]/ ,
          minLength:10,
          maxLength:10,
          message1: "Contact no should start with 6, 7, 8, 9",
          message: "Please enter a valid 10-digit",
        }
      },
      {
        name: "user_address",
        label: "Address",
        placeholder:"Enter Address",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, message: "Address is required" },
      },
      {
        name: "pincode",
        label: "Pin Code",
        placeholder:"Enter Pin Code",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, message: "Pincode is required", maxLength: 6 },
      },
      {
        name: "city",
        label: "City",
        placeholder: "City",
        // type: "dropdown",
        type:"text",
        required: false,
        gridClass: "col-lg-4",
        // options: isMultipleCities ? cities.map(city => ({ label: city.city_name, value: city.city_id })) : [],
        
        disabled: true,
      },
      {
        name: "state",
        label: "State",
        placeholder:"State",
        type: "text",
        required: false,
        gridClass: "col-lg-4",
        // validation: { required: true, message: "State is required" },
         disabled:true
      },
      {
        name: "country",
        label: "Country",
        placeholder:"Country",
        type: "text",
        required: false,
        gridClass: "col-lg-4",
        // validation: { required: true, message: "Country is required" },
         disabled:true
      },
    // {
    //   name: "designationlevel",
    //   label: "Designation Level",
    //   type: "dropdown",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   options: [],
    // },
   {
      name:"role_id",
      label:"Role",
      type:"dropdown",
      required: true,
      gridClass: "col-lg-4",
      options: roleOptions,
      validation: { required: true, message: "Role is required",}
    },
    {
      name: "designation_id",
      label: "Designation",
      required: true,
      type: "dropdown",
      gridClass: "col-lg-4",
      options:designationInputs,
      validation: { required: true, message: "Designation is required",}
    },

    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
      ],
      validation: {
  required: true,
  message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "reportingperson",
    //   label: "Reporting Person",
    //   type: "dropdown",
    //   gridClass: "col-lg-4",
    //   isVisible: false,
    //   required:Required,
    //   validation:{required:true},
    //   options: [],
    // },
    // {
    //   name: "parentDesignation",
    //   label: "Parent Designation",
    //   type: "dropdown",
    //   gridClass: "col-lg-4",
    //   isVisible: false, 
    //   required:Required,
    //   validation:{required:true},
    //   options: [],
    // },
  ];

  useEffect(() => {
    const fetchData = async () => {
      // await fetchDesignationLevels();
      await userTypedropdown();
    };
    fetchData();
  }, []);
  // useEffect(()=>{
  //   if(formData?.business_partner_id){
  //     setFormData({...formData,designationlevel:''})
  //     fetchDesignationLevels()
  //     fetchRoleDropdown()
  //   }
   
  // },[formData?.business_partner_id])
  // useEffect(() => {
  //   if(formData?.business_partner_id){
  //   const fetchData = async () => {
  //     await fetchDesignationLevels();
  //     await fetchRoleDropdown();
  //     //await userTypedropdown()
  //     // await fetchDepartmentDropdown()
  //   }
  //   fetchData();
  // }
  // },[formData?.business_partner_id])

  useEffect(() => {
    fetchRoleDropdown()
  },[])

  const fetchRoleDropdown = async () => {
    try {

      const payload = {
        // business_partner_id: 1  ,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/role/ddlrole",payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const roleOptions = response.data.data.data.map(user => ({
        label: user.NAME,
        value: user.ID,
      }));
      setRoleOptions(roleOptions)

    } catch (error) {
      console.error("Error fetching designation levels:", error);
    }
  };

  useEffect(() => {
    const roleId = formData?.role_id
    if(roleId){
      fetchDesignationLevels(roleId)
    }
  },[formData?.role_id])

  const fetchDesignationLevels = async (roleId) => {
    try {
      const response = await axiosInstance.post(
        "/designation/ddldesignation",
        {
          role_id:roleId,
          business_partner_id:userType==="superadmin"? formData?.business_partner_id:businessPartnerId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const options = response.data.data.data.map((level) => ({
        label: level.NAME,
        value: level.ID,
        level: level.LEVEL,
      }));
      console.log("options<><>",options);

      setDesignationInputs(options);
    } catch (error) {
      console.error("Error fetching designation levels:", error);
    }
  };



//   useEffect(() => {
//    // setFormData({...formData,parentDesignation:''})
//     console.log("formdata<><>",formData);
    
//     const fetchParentDesignations = async (designationLevelId) => {
//       if (!formData.designation_id) return;

//       const selectedLevel = designationInputs.find(input => input.name === "designation_id")
//         ?.options.find(option => option.value === formData.designation_id)?.level;
// console.log("selectedLevel",selectedLevel);
//       if (selectedLevel === 1) {
//         setRequired(false)
//         setShowParentDesignation(false);
//         const updatedInputs = designationInputs.map((input) =>
//           input.name === "reportingperson" ? { ...input, options: [], isVisible: false } : input
//         );
    
//         setDesignationInputs(updatedInputs);
//         return;
//       }
//       else{
//         setRequired(true)
//       }

//       setShowParentDesignation(true);

//       try {

//         // if (userType === "superadmin") {
//         //   payload.business_partner_id = formData.business_partner_id;
//         // } else {
//         //   payload.business_partner_id = businessPartnerId;
//         // }

//         const response = await axiosInstance.post(
//           "/user/ddluserreportingperson",
//           {
//             business_partner_id:formData?.business_partner_id,
//             designation_id: formData.designation_id,
//             level: selectedLevel,
//           },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${authToken}`,
//             }
//           }
//         );

//         const parentDesignationList = response.data.data.data.map(ParentDesignation => ({
//           label: ParentDesignation.NAME,
//           value: ParentDesignation.ID,
//         }));
        
//         const updatedInputs = designationInputs.map((input) =>
//           input.name === "reportingperson" ? { ...input, options: parentDesignationList, isVisible: true } : input
//         );
//         setDesignationInputs(updatedInputs);
//       } catch (error) {
//         console.error("Error fetching parent designations:", error);
//       }
//     };

//    fetchParentDesignations();

//     // if (formData.designationlevel){
//     //   const parentDesignationId = formData.designationlevel;

//     //   if (parentDesignationId){
//     //     fetchParentDesignations(parentDesignationId)
//     //   }
//     // }

//   }, [formData.designation_id, authToken]);

  const handleFormSubmit = async (data) => {
    console.log(formData, "FORMDATA");
    const errors = {};
    let isValid = true;
  
    DesignationInputsTemplate.forEach((field) => {
      if (field.required && !data[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (field.validation && field.validation.pattern && !field.validation.pattern.test(data[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const formattedDOB = format(formData.dob, "yyyy-MM-dd");
    const formatJD = format(formData.jddob, "yyyy-MM-dd");
  
    // Show confirmation alert before proceeding
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
  
          // Prepare payload for API request
          const payload = {
            user_first_name: formData.firstname,
            user_last_name: formData.lastname,
            user_email_id: formData.email,
            user_contact_no: formData.contactno,
            user_dob: formattedDOB,
            user_address: formData.user_address,
            pincode: formData.pincode,
            city_id: formData.city_id,
            state_id: formData.state_id,
            country_id: formData.country_id,
            user_joining_dt: formatJD,
            department_id: 1, // Assuming this is a constant value
            designation_id: formData.designation_id,
            reporting_person_id: formData.reporting_person_id,
            gst_no: formData.gst_no,
            status: formData.status === "Active" ? 1 : 0,
            role_id: formData?.role_id?.toString(),
          };
  
          // Set business partner ID based on user type
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          // Make API call to create user
          const response = await axiosInstance.post(
            "/user/create",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              }
            }
          );
  
          console.log("API Response:", response.data);
  
          // Show success alert after successful creation
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "User added successfully.",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate("/admin/manage-user/user"); // Navigate after user clicks OK
            });
          }
  
        } catch (error) {
          console.error("Error submitting form:", error);
          const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
  
          // Show error alert if API call fails
          Swal.fire({
            title: "Something went wrong",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else {
        // User cancelled the action
        Swal.fire({
          title: "Cancelled",
          text: "User addition cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };

  // useEffect(() => {
    
  // },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })

      const userTypeOptions = response.data.data.data.map(user => ({
        label:user.bp_name,
      value: user.onboard_id,
      }));

      setBusinessPartnerOptions(userTypeOptions)

    }catch(error) {
      console.log(error)
    }
  }

  return (
    <>
     <div>
    {loading ? (
      <Loader />
    ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Add New User</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter User Details
                </span>
                <DynamicForm
                  formConfig={DesignationInputsTemplate}
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  onSubmit={handleFormSubmit}
                  // showParentDesignation={showParentDesignation} 
                  />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => {
                    handleFormSubmit(formData);
                  } }
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
    )}
    </div>
    </>
  );
};

export default AddNewUser;
